import { isNil } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'
import { formatPhoneNumber } from '@/shared/lib'
import { Description } from '@/shared/ui'

import { ChatButton } from './chat-button'

export type Props = {
  hostName: string
  hostPhoneNumber: string
  hostChatRoomUrl: string | null
}

export const HostInformation = ({
  hostName,
  hostPhoneNumber,
  hostChatRoomUrl,
}: Props) => {
  const t = useTranslations('lease_detail.information')

  const showChatButton = !isNil(hostChatRoomUrl)

  return (
    <Card.Item>
      <Card.ItemTitle>{t('landlord')}</Card.ItemTitle>
      <Card.ItemContent className="space-y-6">
        <Description.List>
          <Description.Item label={t('label.name')} value={hostName} />
          <Description.Item
            label={t('label.contact')}
            value={formatPhoneNumber(hostPhoneNumber)}
          />
        </Description.List>
        {showChatButton && <ChatButton chatRoomUrl={hostChatRoomUrl} />}
      </Card.ItemContent>
    </Card.Item>
  )
}
